import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { twMerge } from 'tailwind-merge';

import Logger from '../../../common/Logger';
import { aiFeatureSelector } from '../../Search/selectors/searchSelectors';

/**
 * AI Navigation Button Component
 * Displays AI Voiceover Button based on Statsig gates
 * Only shown for visitors (non-logged-in users)
 */
const AIVoiceoverButton = () => {
  const aiVoiceover = useSelector(aiFeatureSelector('voiceover'));

  useEffect(() => {
    if (aiVoiceover.show) {
      // Track impression on mount
      Logger.accessTelemetry().increment(`topnav.ai_voiceover.impression`);
    }
  }, [aiVoiceover.show]);

  const handleClick = () => {
    // Track click event
    Logger.accessTelemetry().increment(`topnav.ai_voiceover.click`);
  };

  if (!aiVoiceover.show || !aiVoiceover.url || !aiVoiceover.text) {
    return null;
  }

  return (
    <a
      href={aiVoiceover.url}
      onClick={handleClick}
      data-testid={`ai-voiceover-button`}
      data-cy={`ai-voiceover-button`}
      className={twMerge(
        'inline-flex items-center justify-center',
        'font-semibold text-sm',
        'focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2',
        'text-gray-900',
        'rounded-xl',
        'no-underline',
        // Gradient border effect using background
        'p-0.5 bg-gradient-to-r from-purple-600 via-pink-200 to-pink-400'
      )}
      aria-label={`Try ${aiVoiceover.text}`}
    >
      <span
        className="flex items-center w-max hover:bg-transparent rounded-xl p-2 gap-x-2"
        style={{ backgroundColor: '#ffe5fb' }}
      >
        <img
          src={`${__ASSETS_COMMON_IMAGES_URL__}/icons/ai-voiceover-diamond.svg`}
          alt="voiceover icon"
          className="w-4 h-4"
        />
        {aiVoiceover.text}
      </span>
    </a>
  );
};

export default AIVoiceoverButton;
